// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lc-am-base-rich-editor[data-v-234d0745]{border:1px solid #d9d9d9;border-radius:4px;display:flex;flex-direction:column;height:300px}.lc-am-base-rich-editor .richeditor-toolbar[data-v-234d0745]{border-bottom:1px solid #d9d9d9}.lc-am-base-rich-editor .richeditor-editor[data-v-234d0745]{flex:1;overflow:hidden}", ""]);
// Exports
module.exports = exports;
